import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { queryParamsFilters } from 'src/pages/pages-behind-login/chartering/position-list-page/hooks/use-chartering-sub-pages'
import { PageRoute } from 'src/routes/routes-behind-login/page-route'
import { ExactScopeName, useHasScope } from '~hooks/permissions/use-has-scope'

export function usePageShortcuts() {
  const navigate = useNavigate()
  const location = useLocation()
  const isMtUser = useHasScope(ExactScopeName.maerskTankersUser)

  useEffect(() => {
    if (!isMtUser) return

    const handler = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable
      ) {
        return
      }

      if (e.altKey && e.code === 'KeyS') {
        e.preventDefault()

        const isOnPositionList = location.pathname.includes('position-list')

        if (isOnPositionList) {
          navigate(PageRoute.CARGO_LIST)
        } else {
          navigate(`${PageRoute.POSITION_LIST}${queryParamsFilters}`)
        }
      }
    }

    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [isMtUser, navigate, location.pathname])
}
